var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronLeft20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.5261 4.2174a.75.75 0 0 1 .0007 1.0606l-4.7163 4.7223 4.7162 4.7213a.75.75 0 0 1-.0006 1.0606.75.75 0 0 1-1.0606-.0005l-5.2456-5.2512a.75.75 0 0 1 0-1.06l5.2455-5.2524a.75.75 0 0 1 1.0607-.0007Z",
  clipRule: "evenodd"
})));
export { SvgChevronLeft20 as ReactComponent };